import { useEffect } from 'react';
import styles from './Terms.module.css';

export default function Terms() {

    useEffect(() => {
        window.scrollTo(0, 0); // Reset scroll to top on route change
      }, []);
    

    return (       
        <section className={styles.Page} id='terms'>
            <h2 className={styles.PageName}>Terms & Conditions</h2>
              
            <section className={styles.PageContent}>
                <p>Welcome to K. P. Jadhav High School & Junior College's official website. By accessing and using this website, you agree to the following terms:</p>
                <ol>
                    <li>
                        <h3>Informational Purpose Only</h3>
                        <p>- The content on this website is for informational purposes regarding the school, its events, and activities.</p>
                    </li>
                    <li>
                        <h3>Intellectual Property</h3>
                        <p>- All text, images, and other content belong to K. P. Jadhav High School & Junior College unless otherwise stated.</p>
                        <p>- You may not copy, distribute, or modify any content without permission.</p>
                    </li>
                    <li>
                        <h3>Use of Images</h3>
                        <p>- This website features images of school events, students, and staff for documentation and promotional purposes.</p>
                        <p>- If you have concerns about any image, please contact us at kpjadhavjrcollege2016@gmail.com for removal requests.</p>
                    </li>
                    <li>
                        <h3>No User Data Collection</h3>
                        <p>- We do not collect, store, or share any personal information from visitors.</p>
                    </li>
                    <li>
                        <h3>Third-Party Links</h3>
                        <p>- Our website may contain links to third-party websites. We are not responsible for their content or policies.</p>
                    </li>
                    <li>
                        <h3>Changes to Terms</h3>
                        <p>- We reserve the right to update these terms at any time. Please check this page periodically for updates.</p>
                    </li>
                </ol>
                <p>If you have any questions, contact us at kpjadhavjrcollege2016@gmail.com.</p>
            </section>
            
        </section>        
    )
}